import { pluralize } from '@lt/components/utils/userflow';
import { pluralizeFlights } from '@lt/components/utils/pluralizeUtils';
import { i18n } from '@lt/localization';

export const getCountLabel = (flightsCount: number) => {
  const pluralFound = pluralize(flightsCount, [
    i18n.t('checkout.flight.progressbar.find', { count: 1 }),
    i18n.t('checkout.flight.progressbar.find', { count: 2 }),
    i18n.t('checkout.flight.progressbar.find', { count: 2 }),
  ]);
  const pluralFlights = pluralizeFlights(flightsCount);

  return `${pluralFound} ${flightsCount} ${pluralFlights} ${i18n.t(
    'hotel.priceBadge.withValue',
  )} `;
};

export const getProgress = (
  currentValue: number,
  totalValue: number,
  startValue: number,
  isFetchingDone?: boolean,
) => {
  if (isFetchingDone) return 100;
  return (
    Math.floor((currentValue * (100 - startValue)) / totalValue) + startValue ||
    startValue
  );
};
